import PropTypes from 'prop-types';

const { __ } = wp.i18n;
const { Component } = wp.element;
const { ToggleControl } = wp.components;

class ConditionalHeadingComponent extends Component {
	constructor(props) {
		super( props );
	}

	render() {
		if ( ! kadenceCustomizerControlsData.source ) {
			return null;
		}
		if ( ! this.props.customizer( 'current_header_preview' ) ) {
			return null;
		}
		const current = this.props.customizer( 'current_header_preview' ).get();
		const settings = this.props.customizer( 'conditional_headers' ).get();
		const label = Object.keys( settings.items ).map( ( item ) => {
			if ( settings.items[ item ].id === current ) {
				return settings.items[ item ].label;
			}
		} );
		return (
			<div className="kadence-control-field kadence-conditional-title-control">
				{ this.props.control.params.label && (
					<span class="customize-control-title">
						{ this.props.control.params.label }
					</span>
				) }
				{ label && (
					<span class="customize-control-description">
						{ label }
					</span>
				) }
			</div>
		);
	}
}

ConditionalHeadingComponent.propTypes = {
	control: PropTypes.object.isRequired,
	customizer: PropTypes.object.isRequired
};

export default ConditionalHeadingComponent;
